<template>
  <div class="sm-error-block">
    <h4 class="sm-txt-center">{{title}}</h4>
    <p>{{text}}</p>
    <slot name="content"></slot>
    <btn-block
      :text="btnText"
      @click="$emit('close')"
    />
  </div>
</template>

<script>
export default {
  name: 'error-block',
  props: {
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Error!'
    },
    btnText: {
      type: String,
      default: 'Close'
    }
  }
}
</script>